import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chat Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chat-outline',
    templateUrl: './icon-chat-outline.component.html',
    styleUrls: ['./icon-chat-outline.component.scss'],
    standalone: false
})
export class IconChatOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
